const DEFAULT_RECEIVABLE_FILTERS = {
  customerRef: null,
  unitRef: null,
  basis: "nominal",
  page: 1,
  pageSize: 25,
};

const IDLE_LOADING = {
  cashflow: false,
  cashflowBreakdown: false,
  itemVariances: false,
  customerReceipts: false,
  customerUnits: false,
};

export default (state, action) => {
  switch (action.type) {
    case "BOOTSTRAP_REQUEST":
      return { ...state, bootstrapStatus: "loading", error: null };
    case "BOOTSTRAP_SUCCESS":
      return {
        ...state,
        bootstrapStatus: "ready",
        accessByCompany: action.accessByCompany,
        selectedCompanyId: action.selectedCompanyId,
        metadata: action.metadata,
        cashflowBreakdownError: null,
        error: null,
      };
    case "BOOTSTRAP_FAILURE":
      return {
        ...state,
        bootstrapStatus: "error",
        accessByCompany: {},
        selectedCompanyId: null,
        metadata: null,
        cashflowBreakdownError: null,
        customerReceipts: null,
        customerUnits: null,
        customerUnitsError: null,
        loading: IDLE_LOADING,
        error: action.error,
      };
    case "COMPANY_SELECTED":
      return {
        ...state,
        selectedCompanyId: action.companyId,
        metadata: action.metadata,
        cashflow: null,
        cashflowBreakdown: null,
        cashflowBreakdownError: null,
        itemVariances: null,
        customerReceipts: null,
        customerUnits: null,
        customerUnitsError: null,
        loading: IDLE_LOADING,
        filters: { legalEntityId: null, projectKey: null, costCenterId: null },
        receivableFilters: DEFAULT_RECEIVABLE_FILTERS,
        error: null,
      };
    case "PERIOD_CHANGED":
      return {
        ...state,
        period: { ...state.period, ...action.period },
        cashflow: null,
        cashflowBreakdown: null,
        cashflowBreakdownError: null,
        itemVariances: null,
        customerReceipts: null,
        customerUnits: null,
        customerUnitsError: null,
        receivableFilters: { ...state.receivableFilters, page: 1 },
        loading: IDLE_LOADING,
      };
    case "FILTERS_CHANGED":
      return {
        ...state,
        filters: { ...state.filters, ...action.filters },
        cashflow: null,
        cashflowBreakdown: null,
        cashflowBreakdownError: null,
        itemVariances: null,
        customerReceipts: null,
        customerUnits: null,
        customerUnitsError: null,
        receivableFilters: { ...state.receivableFilters, page: 1 },
        loading: IDLE_LOADING,
      };
    case "RECEIVABLE_FILTERS_CHANGED":
      return {
        ...state,
        receivableFilters: { ...state.receivableFilters, ...action.filters },
        customerReceipts: null,
        customerUnits: null,
        customerUnitsError: null,
        loading: {
          ...state.loading,
          customerReceipts: false,
          customerUnits: false,
        },
      };
    case "CASHFLOW_REQUEST":
      return {
        ...state,
        cashflow: null,
        cashflowBreakdown: null,
        cashflowBreakdownError: null,
        loading: { ...state.loading, cashflow: action.requestKey, cashflowBreakdown: false },
        error: null,
      };
    case "CASHFLOW_SUCCESS":
      if (state.loading.cashflow !== action.requestKey) return state;
      return { ...state, cashflow: action.data, loading: { ...state.loading, cashflow: false } };
    case "CASHFLOW_FAILURE":
      if (state.loading.cashflow !== action.requestKey) return state;
      return { ...state, error: action.error, loading: { ...state.loading, cashflow: false } };
    case "CASHFLOW_BREAKDOWN_REQUEST":
      return {
        ...state,
        cashflowBreakdown: null,
        cashflowBreakdownError: null,
        loading: { ...state.loading, cashflowBreakdown: action.requestKey },
      };
    case "CASHFLOW_BREAKDOWN_SUCCESS":
      if (state.loading.cashflowBreakdown !== action.requestKey) return state;
      return {
        ...state,
        cashflowBreakdown: action.data,
        cashflowBreakdownError: null,
        loading: { ...state.loading, cashflowBreakdown: false },
      };
    case "CASHFLOW_BREAKDOWN_FAILURE":
      if (state.loading.cashflowBreakdown !== action.requestKey) return state;
      return {
        ...state,
        cashflowBreakdown: null,
        cashflowBreakdownError: action.error,
        loading: { ...state.loading, cashflowBreakdown: false },
      };
    case "ITEM_VARIANCES_REQUEST":
      return {
        ...state,
        loading: { ...state.loading, itemVariances: action.requestKey },
        error: null,
      };
    case "ITEM_VARIANCES_SUCCESS":
      if (state.loading.itemVariances !== action.requestKey) return state;
      return {
        ...state,
        itemVariances: action.data,
        loading: { ...state.loading, itemVariances: false },
      };
    case "ITEM_VARIANCES_FAILURE":
      if (state.loading.itemVariances !== action.requestKey) return state;
      return {
        ...state,
        error: action.error,
        loading: { ...state.loading, itemVariances: false },
      };
    case "CUSTOMER_RECEIPTS_REQUEST":
      return {
        ...state,
        customerReceipts: null,
        customerUnits: null,
        customerUnitsError: null,
        loading: {
          ...state.loading,
          customerReceipts: action.requestKey,
          customerUnits: false,
        },
        error: null,
      };
    case "CUSTOMER_RECEIPTS_SUCCESS":
      if (state.loading.customerReceipts !== action.requestKey) return state;
      return {
        ...state,
        customerReceipts: action.data,
        loading: { ...state.loading, customerReceipts: false },
      };
    case "CUSTOMER_RECEIPTS_FAILURE":
      if (state.loading.customerReceipts !== action.requestKey) return state;
      return {
        ...state,
        error: action.error,
        loading: { ...state.loading, customerReceipts: false },
      };
    case "CUSTOMER_UNITS_REQUEST":
      return {
        ...state,
        customerUnits: null,
        customerUnitsError: null,
        loading: { ...state.loading, customerUnits: action.requestKey },
      };
    case "CUSTOMER_UNITS_SUCCESS":
      if (state.loading.customerUnits !== action.requestKey) return state;
      return {
        ...state,
        customerUnits: action.data,
        customerUnitsError: null,
        loading: { ...state.loading, customerUnits: false },
      };
    case "CUSTOMER_UNITS_FAILURE":
      if (state.loading.customerUnits !== action.requestKey) return state;
      return {
        ...state,
        customerUnits: null,
        customerUnitsError: action.error,
        loading: { ...state.loading, customerUnits: false },
      };
    case "ERROR_CLEARED":
      return {
        ...state,
        error: null,
        cashflowBreakdownError: null,
        customerUnitsError: null,
      };
    default:
      return state;
  }
};
